import React from 'react';
import BudgetDetails from 'usage/containers/Budget/components/BudgetDetails';

const BudgetChart = ({ budget, viewType, overrideCurrency }) => (
  <div>
    <BudgetDetails budget={budget} isDashboardPanel dashboardViewType={viewType} overrideCurrency={overrideCurrency} />
  </div>
);
export default BudgetChart;

